import { FeedingPlanType } from '../common'

export const idVersionMustNotExist = (data: unknown) => {
  return (
    (data as { id: string; version: number }).id === undefined &&
    (data as { id: string; version: number }).version === undefined
  )
}
export const generateRequiredIdVersionError = (name = '') => ({
  message: `Both 'id' and 'version' must be required together for ${name}`,
  path: ['id', 'version'],
})

export const LYKA_HALF_BOWL_FEEDING_PLAN_TYPES = new Set<FeedingPlanType>([
  FeedingPlanType.half_bowl,
  FeedingPlanType.starter_box_half,
  FeedingPlanType.starter_box_full_1w_over_2w,
])

/**
 * Topper and its starter box supply a fixed 125g a day rather than a fraction of the
 * Full-Bowl Serving, so they must never be sized, priced or named as Full Bowl.
 */
export const LYKA_TOPPER_FEEDING_PLAN_TYPES = new Set<FeedingPlanType>([
  FeedingPlanType.topper,
  FeedingPlanType.starter_box_topper,
])

export const TOPPER_DAILY_SERVING_GRAMS = 125

/** Topper and Topper Starter Box cadences are fixed; the customer can't change them. */
export const TOPPER_CADENCE_IN_WEEKS = 4
export const TOPPER_STARTER_BOX_CADENCE_IN_WEEKS = 2

/**
 * Topper plans are priced as a 125g-a-day Custom Delivery: the daily price is worked out over the
 * standard cadence the subscription cadence table gives a 125g-a-day Full Bowl.
 */
export const TOPPER_PRICING_BASE_CADENCE_IN_WEEKS = 8
